import { RecoveryUsername } from 'features/recovery-username';

export const RecoveryUsernameRoute = () => {
  return <RecoveryUsername />;
};
